<script  setup>
  const store = useDialogStore();
  const close =()=>{
    store.close();
  }
  const icon = computed( ()=>{
    return store.status == "info" ? "mdi-information" : "mdi-alert-circle";
  });
  const color = computed( ()=>{
    return store.status == "info" ? "blue" : "red";
  });
</script>
<template>
  <div>
      <v-dialog v-model="store.enabled" width="auto" >
        <v-card min-width="300" max-width="400"  :prepend-icon="icon" :title="store?.title">
          <v-divider></v-divider>
          <v-card-text>
            <div class="mb-1">
              {{store?.text}}
            </div>
          </v-card-text>
          <template v-slot:actions>
            <v-btn class="ms-auto bg-blue" text="確認" @click="close"></v-btn>
          </template>
        </v-card>
    </v-dialog>
  </div>
</template>

<style>

</style>